import zoomInIcon from "../../../../assets/images/zoom-in.svg";
import zoomOutIcon from "../../../../assets/images/zoom-out.svg";

export const ZoomControls = ({ handleZoomIn, handleZoomOut }) => {
    return (
        <div class="d-flex flex-column zoom col-2">
            <a class="btn-circle ms-2" onClick={handleZoomIn}>
                <img src={zoomInIcon} width={16}/>
            </a>
            <div class="vertical-line my-2"></div>
            <a class="btn-circle ms-2" onClick={handleZoomOut}>
                <img src={zoomOutIcon} width={16}/>
            </a>
        </div>
    )
}